const actions = {
  CHATGPT_VIEW: "CHATGPT_VIEW",
}

export default actions;
